import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import { createHead } from '@unhead/vue/client';
import i18n from '../i18n';
import App from './App.vue';
import RouteList from './pages/RouteList.vue';
import RouteSingle from './pages/RouteSingle.vue';
import RouteStop from './pages/RouteStop.vue';
import StopSingle from './pages/StopSingle.vue';

const routes = [
    {
        name: 'route-list',
        path: '/',
        component: RouteList,
    },
    {
        name: 'stop-single',
        path: '/:stop(\\d{4}.*?)/:date(\\d{4}-\\d{2}-\\d{2})?',
        component: StopSingle,
    },
    {
        name: 'route-single',
        path: '/:route(\\d{1,3}[A-Z]?)/:direction?/:date(\\d{4}-\\d{2}-\\d{2})?',
        component: RouteSingle,
    },
    {
        name: 'route-stop',
        // The stop param starts with 4 digits, but so does a date (\d{4}-\d{2}-\d{2}). Without the
        // negative lookahead, a route-single URL like /936/direction/2026-07-10 would be captured here
        // (stop=2026-07-10, no date). The lookahead rejects a segment that is a bare date so such URLs
        // fall through to route-single. Use [^/]* (not .*) so stop stays within a single segment:
        // in JS `.` matches `/`, so `.*` would greedily swallow the trailing /:date into stop.
        // Closing parens are escaped as \) because vue-router's param regex parser otherwise treats
        // the first unescaped ) as the end of the custom regex.
        path: '/:route(\\d{1,4}[A-Z]?)/:direction/:stop((?!\\d{4}-\\d{2}-\\d{2}(?:/|$\\)\\)\\d{4}[^/]*)/:date(\\d{4}-\\d{2}-\\d{2})?',
        component: RouteStop,
    },
];

const basePath = document.documentElement.lang === 'en'
    ? '/en/schedules-and-routes/bus-schedule/all-routes'
    : '/horaires-et-trajets/horaires-des-bus/tous-les-parcours';

const router = createRouter({
    history: createWebHistory(basePath),
    routes,
});

const pinia = createPinia();
const app = createApp(App);
const head = createHead();

app.use(head);
app.use(pinia);
app.use(i18n);
app.use(router);
app.mount('#vue-schedules');
